import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './Panel_Values.scss';
import { convertValueDBToUI, DBDef_Variable, resolveValueDisplay, valueType_Enumerated, valueType_Range, valueType_StandardRange, valueType_SubEnumerated, valueType_SubRange, valueType_SubTime, valueType_Time, valueType_Tuple, } from '@app/hcs-shared/core';
import { DataStatus, EventType_Create, EventType_Delete, EventType_Query, EventType_Update, LL_H_C, LL_V_C, LL_V_L, ProtoComponent, TS_CollapsableContainer, TS_Table, TS_Tabs } from '@nu-art/thunderstorm-frontend/index';
import { arrayToMap, asArray, dbObjectToId, Filter, sortArray } from '@nu-art/ts-common';
import { NormalValuesTable } from './Editors/index.js';
import { Panel_Header } from '../../shared-components/index.js';
import { ICONS } from '@app/styles';
import { Component_ReferencesTable } from '../references/index.js';
import { handleError } from '../../../utils.js';
import { ModuleFE_Expression, ModuleFE_MeasurementUnit, ModuleFE_Reference, ModuleFE_Value, ModuleFE_Variable, } from '../../../_entity.js';
import { expressionToValue } from './expressionToValue/expressionToValue.js';
import { ExpressionType_InRange } from '@app/hcs-shared/expression';
export class Panel_Values extends ProtoComponent {
    // ######################### Static #########################
    static defaultProps = {
        keys: ['selected', 'filterValues'],
    };
    // ######################### Life Cycle #########################
    __onExpressionUpdated(...params) {
        const selectedVarId = this.getQueryParam('selected', {})[DBDef_Variable.dbKey];
        if (asArray(params[1])[0].associatedVar !== selectedVarId)
            return;
        switch (params[0]) {
            case EventType_Query:
                return;
            case EventType_Create:
            case EventType_Delete:
            case EventType_Update:
                break;
        }
        this.reDeriveState();
    }
    __onValueUpdated(...params) {
        switch (params[0]) {
            case EventType_Query:
                return;
            case EventType_Create:
            case EventType_Delete:
            case EventType_Update:
                break;
        }
        this.reDeriveState();
    }
    __onVariableUpdated(...params) {
        const selectedVarId = this.getQueryParam('selected', {})[DBDef_Variable.dbKey];
        if (params[0] === EventType_Update && params[1]._id === selectedVarId)
            this.forceUpdate();
    }
    deriveStateFromProps(nextProps, state) {
        state.attributeValuesMap = {};
        state.attributeVariablesMap = {};
        const selectedVarId = this.getQueryParam('selected', {})[DBDef_Variable.dbKey];
        const selectedVariable = ModuleFE_Variable.cache.unique(selectedVarId);
        if (!selectedVarId || !selectedVariable)
            return state;
        const filter = this.getQueryParam('filterValues');
        state.valuesMap = ModuleFE_Value.cache.arrayToMap(dbObjectToId);
        const dbValue = state.valuesMap[selectedVariable.valueId];
        const measurementUnitsMap = arrayToMap(ModuleFE_MeasurementUnit.cache.all(), dbObjectToId);
        state.values = [];
        state.parentValue = convertValueDBToUI(dbValue, {
            values: state.valuesMap,
            measurementUnits: measurementUnitsMap
        });
        if (!state.parentValue)
            return state;
        state.values = ((state.parentValue.type === valueType_Enumerated || state.parentValue.type === valueType_Tuple || state.parentValue.type === valueType_SubEnumerated || state.parentValue.type === valueType_SubTime)
            ? state.parentValue.data?.scope
            : state.parentValue.data.subsets);
        if (state.parentValue.type === valueType_Time)
            state.values = state.parentValue.data.timeRanges;
        if (state.parentValue.type === valueType_StandardRange)
            state.values = [state.parentValue];
        //Filter results if filter exists
        if (filter && state.values) {
            const _filter = new Filter((item) => {
                if (item.type === valueType_SubRange)
                    return [item.data?.label];
                return [item.data?.value];
            });
            state.values = _filter.filter(state.values, filter);
        }
        //Sort Values
        if (state.values && !state.values.some(value => value.type !== valueType_SubRange))
            state.values = sortArray(sortArray(state.values, v => v.data.scope[1]), v => v.data.scope[0]);
        //Get references for the selected variable
        state.references = ModuleFE_Reference.cache.filter(ref => {
            return (ref.type === 'loinc' || ref.type === 'snomed') &&
                selectedVariable.referenceIds.includes(ref._id);
        });
        const attVarIds = selectedVariable.attributes?.map(att => att.varId) || [];
        const attValueIds = selectedVariable.attributes?.map(att => att.valueId) || [];
        state.attributeVariablesMap = arrayToMap(ModuleFE_Variable.cache.filter(item => attVarIds.includes(item._id)), dbObjectToId);
        state.attributeValuesMap = arrayToMap(attValueIds.map(id => convertValueDBToUI(state.valuesMap[id], {
            values: state.valuesMap,
            measurementUnits: measurementUnitsMap
        })), i => i._id);
        return state;
    }
    // ######################### Logic #########################
    async isReady() {
        return ModuleFE_Variable.getDataStatus() === DataStatus.ContainsData && ModuleFE_Value.getDataStatus() === DataStatus.ContainsData;
    }
    // ######################### Render #########################
    renderHeader() {
        const selectedVariableId = this.getQueryParam('selected', {})[DBDef_Variable.dbKey];
        const selectedVariable = ModuleFE_Variable.cache.unique(selectedVariableId);
        return _jsx(Panel_Header, { config: { filter: this.getQueryParam('filterValues') }, onFilterChanged: (filter) => {
                this.setQueryParam('filterValues', filter);
            }, headerClassName: 'value-area__header', title: { label: selectedVariable?.name || 'Values', className: 'value-area__header__title' }, qsearchId: 'value-area' });
    }
    resolveHeaderDisplay = () => {
        if (this.state.parentValue?.type === valueType_Time)
            return 'Time Ranges';
        if (!this.state.parentValue || this.state.parentValue.type !== valueType_Range)
            return 'Scope';
        const fullRange = this.state.parentValue.data.scope.join(' ... ');
        const measurementUnitAsString = this.state.parentValue.data.measurementUnit?.unitAsString;
        return `Full range: ${fullRange}${measurementUnitAsString ? ` (${measurementUnitAsString})` : ''}`;
    };
    renderValuesList() {
        const rows = this.state.values || [];
        if (!rows.length)
            return this.renderMessage('No values found');
        return _jsx(TS_Table, { rows: rows, header: ['data'], headerRenderer: columnKey => _jsx(LL_H_C, { className: 'th-data unselectable', children: this.resolveHeaderDisplay() }), cellRenderer: (prop, item, index) => {
                if (prop === 'data') {
                    return _jsx("div", { className: 'td-data unselectable', children: resolveValueDisplay(item) });
                }
            } });
    }
    renderAttributes = () => {
        const selectedVariableId = this.getQueryParam('selected', {})[DBDef_Variable.dbKey];
        if (!selectedVariableId)
            return this.renderMessage('No variable selected');
        const selectedVariable = ModuleFE_Variable.cache.unique(selectedVariableId);
        if (!selectedVariable)
            return this.renderMessage(`Variable with id ${selectedVariableId} not in cache`);
        return _jsx(LL_V_L, { className: 'attributes-tab', children: selectedVariable?.attributes?.map(att => {
                const variable = this.state.attributeVariablesMap[att.varId];
                const value = this.state.attributeValuesMap[att.valueId];
                return _jsx(TS_CollapsableContainer, { customCaret: _jsx(ICONS.advisorArrowDown.component, {}), headerRenderer: variable.name, containerRenderer: _jsx(LL_H_C, { className: 'values', children: value.data?.scope.map((val, i) => {
                            return _jsx("div", { className: 'value-tag', children: val.data?.value }, i);
                        }) }) }, att.varId);
            }) });
    };
    renderTabs() {
        const selectedVariableId = this.getQueryParam('selected', {})[DBDef_Variable.dbKey];
        if (!selectedVariableId)
            return this.renderMessage('No variable selected');
        const selectedVariable = ModuleFE_Variable.cache.unique(selectedVariableId);
        if (!selectedVariable)
            this.logError(`No variable found in cache for id ${selectedVariableId}`);
        const tabs = [
            {
                title: 'Values',
                content: () => {
                    let isNormal = false;
                    if (this.state.values?.[0]?.type === valueType_StandardRange)
                        isNormal = true;
                    const value = { ...this.state.valuesMap[this.state.values[0]?._id] };
                    if (value.type === valueType_StandardRange) {
                        const expression = ModuleFE_Expression.cache.find(expr => expr.associatedVar === selectedVariableId && expr.expressionType !== ExpressionType_InRange.dbKey);
                        if (!expression)
                            return;
                        const rangesValueData = expressionToValue(expression);
                        if (!rangesValueData || !expression)
                            return _jsx("div", { children: "Cannot present ranges due of complex range expression" });
                        value.data = {
                            ...value.data,
                            ...rangesValueData
                        };
                    }
                    return _jsxs("div", { className: 'values-list custom-scrollbar__vertical', children: [isNormal && _jsx(NormalValuesTable, { value: value, editable: false }), !isNormal && this.renderValuesList()] });
                },
                uid: 'values'
            },
            {
                title: 'References',
                content: () => {
                    const onReferenceUpsert = async (reference, originRef) => {
                        if (!selectedVariable)
                            return;
                        if (originRef._id && originRef._id !== reference._id) {
                            const originIndex = selectedVariable.referenceIds.findIndex(id => id === originRef._id);
                            selectedVariable.referenceIds.splice(originIndex, 1);
                        }
                        const index = selectedVariable.referenceIds.findIndex(id => id === reference._id);
                        if (index === -1) {
                            selectedVariable.referenceIds.push(reference._id);
                            try {
                                await ModuleFE_Variable.v1.upsert(selectedVariable).executeSync();
                            }
                            catch (e) {
                                handleError(e);
                            }
                        }
                        this.forceUpdate();
                    };
                    const onReferenceDeleted = async (referenceId) => {
                        if (!selectedVariable)
                            return;
                        const index = selectedVariable.referenceIds.findIndex(id => id === referenceId);
                        if (index !== -1) {
                            selectedVariable.referenceIds.splice(index, 1);
                            try {
                                await ModuleFE_Variable.v1.upsert(selectedVariable).executeSync();
                            }
                            catch (e) {
                                handleError(e);
                            }
                            this.forceUpdate();
                        }
                    };
                    return _jsx("div", { className: 'list-wrapper custom-scrollbar__vertical', children: selectedVariable && _jsx(Component_ReferencesTable, { blockEdit: true, referenceIds: selectedVariable.referenceIds, onReferenceUpsertCallback: onReferenceUpsert, onReferenceDeletedCallback: onReferenceDeleted, allowedRefs: ['snomed', 'loinc'] }) });
                },
                uid: 'refs'
            },
            {
                title: 'Attributes',
                uid: 'attributes',
                content: this.renderAttributes,
            }
        ];
        return _jsx(TS_Tabs, { tabs: tabs });
    }
    renderMessage(message) {
        return _jsx(LL_V_L, { className: 'match_parent', style: { justifyContent: 'center', alignItems: 'center' }, children: message });
    }
    render() {
        return _jsxs(LL_V_C, { className: 'value-area', children: [this.renderHeader(), this.renderTabs()] });
    }
}
//# sourceMappingURL=Panel_Values.js.map